import { useTranslation } from 'react-i18next';
import { LOCALES, LOCALE_LABELS, isLocale } from '@worki/shared';
import { changeLocale } from '../i18n.js';
import { Select } from './ui.js';

/**
 * Language picker. Options are labelled with each language's endonym, so a user
 * who cannot read the current interface can still find their own language.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  return (
    <Select
      className="w-auto"
      value={i18n.language}
      aria-label={t('common.language')}
      onChange={(next) => {
        if (isLocale(next)) void changeLocale(next);
      }}
    >
      {LOCALES.map((locale) => (
        <option key={locale} value={locale}>
          {LOCALE_LABELS[locale]}
        </option>
      ))}
    </Select>
  );
}
